/* MCR · Journal (<mcr-journal>): the lead story rotates on a slow progress rail. The image reveals as the
   section enters view; hover/focus pauses; the pause button gives direct control. Side stories show the
   stories that are not in the lead and stay clickable throughout. */
(function () {
  if (customElements.get('mcr-journal')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  class McrJournal extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.slides = [].slice.call(this.querySelectorAll('[data-slide]'));
      this.items = [].slice.call(this.querySelectorAll('[data-item]'));
      this.bars = [].slice.call(this.querySelectorAll('.mcr-jr__bar, .mcr-jr__tab'));
      this.nowEl = this.querySelector('[data-now]');
      this.toggleBtn = this.querySelector('[data-toggle]');
      this.n = this.slides.length;
      this.ms = parseInt(this.dataset.interval, 10) || 8000;
      this.auto = this.dataset.autoplay === 'true' && this.n > 1 && !reduce.matches;
      this.index = 0;
      this.userPaused = false;
      this.hover = false;
      this.inView = false;
      this.elapsed = 0;
      var self = this;

      this.addEventListener('click', function (e) {
        var go = e.target.closest('[data-go]');
        if (go) { self.go(parseInt(go.getAttribute('data-go'), 10)); return; }
        if (e.target.closest('[data-toggle]')) { self.userPaused = !self.userPaused; self.sync(); }
      });
      this.addEventListener('pointerenter', function () { self.hover = true; self.sync(); });
      this.addEventListener('pointerleave', function () { self.hover = false; self.sync(); });
      this.addEventListener('focusin', function () { self.hover = true; self.sync(); });
      this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) { self.hover = false; self.sync(); } });

      if ('IntersectionObserver' in window) {
        if (!reduce.matches) this.classList.add('is-pre');
        new IntersectionObserver(function (en) {
          self.inView = en[0].isIntersecting;
          if (self.inView) self.classList.add('is-in');
          self.sync();
        }, { threshold: 0.3 }).observe(this);
      } else {
        this.inView = true;
      }
      this.sync();
    }

    running() { return this.auto && !this.userPaused && !this.hover && this.inView && !document.hidden; }

    go(i) {
      if (isNaN(i) || i === this.index) return;
      var prev = this.index;
      this.index = (i + this.n) % this.n;
      var self = this;
      this.slides.forEach(function (s, k) {
        s.classList.remove('is-leaving');
        var on = k === self.index;
        if (k === prev && !on) s.classList.add('is-leaving');
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('.mcr-jr__title a').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
      });
      this.items.forEach(function (it, k) { it.hidden = k === self.index; });
      var tl = this.querySelector('.mcr-jr__tabs'), at = this.bars[this.index];
      if (tl && at && tl.scrollWidth > tl.clientWidth) tl.scrollTo({ left: at.offsetLeft - tl.offsetLeft, behavior: 'smooth' });
      this.bars.forEach(function (b, k) {
        var on = k === self.index;
        b.classList.toggle('is-active', on);
        b.classList.toggle('is-done', k < self.index);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (this.nowEl) this.nowEl.textContent = pad(this.index + 1);
      this.elapsed = 0;
      this.last = 0;
      this.paint();
    }

    sync() {
      var on = this.running();
      this.classList.toggle('is-paused', this.userPaused);
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-label', this.toggleBtn.getAttribute(this.userPaused ? 'data-label-play' : 'data-label-pause'));
      if (on && !this.raf) { this.last = 0; this.raf = requestAnimationFrame(this.tick.bind(this)); }
      if (!on && this.raf) { cancelAnimationFrame(this.raf); this.raf = 0; }
    }

    tick(t) {
      this.raf = 0;
      if (!this.running()) return;
      if (this.last) this.elapsed += t - this.last;
      this.last = t;
      if (this.elapsed >= this.ms) this.go(this.index + 1);
      this.paint();
      this.raf = requestAnimationFrame(this.tick.bind(this));
    }

    paint() {
      var bar = this.bars[this.index];
      if (bar) bar.style.setProperty('--p', Math.min(1, this.elapsed / this.ms));
    }
  }
  customElements.define('mcr-journal', McrJournal);
})();
